import { render, staticRenderFns } from "./OzDrawerConfirmationDialog.vue?vue&type=template&id=490c3523&"
import script from "./OzDrawerConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./OzDrawerConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports